import NotFoundIcon from "assets/images/404-error.png";

const Page404 = () => {
	return (
		<div className="page-404">
			<img className="page-404__icon" src={NotFoundIcon} alt="page-not-found" />

			<h1 className="page-404__title">The page you were looking for does not exist</h1>
		</div>
	);
};

export default Page404;
